module.exports = __webpack_public_path__ + "img/page.49f7ba28.png";